import { useQuery } from '@tanstack/react-query';
import type { Network } from '@sbclite/core';
import { api } from '../services/api';

interface MediaRealmsResponse {
  success: boolean;
  data: Network.MediaRealmInfo[];
}

function isMediaRealmArray(value: unknown): value is Network.MediaRealmInfo[] {
  return Array.isArray(value);
}

export function useMediaRealms() {
  return useQuery({
    queryKey: ['media-realms'],
    queryFn: async () => {
      const response = await api.get<MediaRealmsResponse | Network.MediaRealmInfo[]>('/api/media-realms');
      if (isMediaRealmArray(response.data)) return response.data;
      return response.data.data;
    },
  });
}
